import { render, staticRenderFns } from "./perspective-2030-item.vue?vue&type=template&id=7275b2f4&scoped=true"
import script from "./perspective-2030-item.vue?vue&type=script&lang=js"
export * from "./perspective-2030-item.vue?vue&type=script&lang=js"
import style0 from "./perspective-2030-item.vue?vue&type=style&index=0&id=7275b2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7275b2f4",
  null
  
)

export default component.exports